<h2 class="text-center mb-4">Log in</h2>
<p *ngIf="isLoginError && loginMsg" class="alert alert-warning font-weight-bold text-center" role="alert">{{loginMsg}}</p>
<form [formGroup]="loginForm" name="loginForm" class="m-0" (ngSubmit)="OnSubmit()">
  <div class="fieldset">
    <label for="Email" class="legend">Email</label>
    <input type="email" name="Email" id="Email" class="text-field" formControlName="email" autocomplete="username" required>
    <div class="formError" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
      <span *ngIf="loginForm.get('email')?.hasError('required')">Email is required</span>
      <span *ngIf="loginForm.get('email')?.hasError('email')">Enter a valid email</span>
    </div>
  </div>
  <div class="fieldset">
    <label for="Password" class="legend">Password</label>
    <div class="password-field">
      <input [type]="showPassword ? 'text' : 'password'" name="Password" id="Password" class="text-field" formControlName="password" autocomplete="current-password" required>
      <button type="button" class="password-toggle" (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'" [attr.aria-pressed]="showPassword">
        <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
      </button>
    </div>
    <div class="formError" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
      <span *ngIf="loginForm.get('password')?.hasError('required')">Password is required</span>
    </div>
    <p class="text-links-wrap"><a routerLink="/access/forgotpassword" class="text-link">Forgot your password? </a><a routerLink="/access/resendemailverification" class="text-right text-link">Resend verification email</a></p>
  </div>
  <button *ngIf="!this.loginService_.isLoading; else isLoading" type="submit" class="btn m-auto" [disabled]="this.loginForm.invalid">Log in</button>
  <ng-template #isLoading>
    <button class="btn btn--loading" type="button">Logging in...</button>
  </ng-template>
  <div class="fieldset mt-3">
    <p class="text-center text-sm mb-1">Or</p>
    <hr class="m-0 mb-2"/>
      <iframe [src]="googleauthuri" title="Sign in with Google" width="100%" height="50px" scrolling="no" frameborder="0"></iframe>
  </div>
</form>
